var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AlertDismiss',{ref:"alertDismiss",staticClass:"mx-2"}),_c('DocumentTypeModal',{ref:"dashboardModal"}),(_vm.load)?_c('LoadCard'):_c('doughnut-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions},on:{"click":_vm.handleChartClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }